import { fetchAuthSession } from "@aws-amplify/auth";

export const API_PRESIGN_IMAGE =
  "https://hiuyw6ij1d.execute-api.us-west-2.amazonaws.com/default/generate-presigned-url";

export const API_GET_NEWSLETTER =
  "https://dmx2yi3kp7.execute-api.us-west-2.amazonaws.com/default/get-sent-newsletter";

export const API_GET_TEMPLATES =
  "https://tli3jwvvnc.execute-api.us-west-2.amazonaws.com/default/get-newsletter-templates";

export const API_SAVE_TEMPLATE =
  "https://266t660l50.execute-api.us-west-2.amazonaws.com/default/save-newsletter-template";

export const API_GET_TEMPLATE =
  "https://ortqkzgl0b.execute-api.us-west-2.amazonaws.com/default/get-one-newsletter-template";

export const API_SAVE_NEWSLETTER =
  "https://lq4s6m64oh.execute-api.us-west-2.amazonaws.com/default/save-newsletter";

export const API_SEND_NEWSLETTER =
  "https://tmfslgwlea.execute-api.us-west-2.amazonaws.com/default/send-newsletter";

export const API_LIST_NEWSLETTERS =
  "https://knf6t42369.execute-api.us-west-2.amazonaws.com/default/list-sent-newsletters";

export const API_NEWSLETTER_STATS =
  "https://zld49v8sc4.execute-api.us-west-2.amazonaws.com/default/get-newsletter-stats";
export const API_SUBSCRIBER_ENGAGEMENT =
  "https://psxowbh41m.execute-api.us-west-2.amazonaws.com/default/get-subscriber-engagement";
export const API_TRACK_OPEN =
  "https://4wot5b8hul.execute-api.us-west-2.amazonaws.com/default/track-open";
export const API_TRACK_CLICK =
  "https://v3i9vaezyh.execute-api.us-west-2.amazonaws.com/default/track-click";
export const API_UNSUBSCRIBE =
  "https://r8ki2t9ohc.execute-api.us-west-2.amazonaws.com/default/handle-unsubscribe";

export const getIdToken = async () => {
  const s = await fetchAuthSession();
  return s?.tokens?.idToken?.toString();
};

export const getRequiredIdToken = async () => {
  const token = await getIdToken();
  if (!token) {
    throw new Error("Missing Cognito ID token. Please sign in and try again.");
  }
  return token;
};
